export const FILTER_TYPE = {
  BOOKED: 'booked',
  STANDBYLIST: 'standbyList',
  WAITLIST: 'waitlist',
  SEATED: 'seated',
  CANCELLED: 'cancelled',
  FINISHED: 'finished',
  CONFLICTS: 'conflicts'
};

export const FILTER_EMPTY_TILE_TYPE = {
  BOOKED: 'booked list is empty',
  STANDBYLIST: 'standby list is empty',
  WAITLIST: 'waitlist is empty',
  SEATED: 'seated list is empty',
  CANCELLED: 'cancelled list is empty',
  FINISHED: 'finished list is empty',
};
